import { useContext } from "react";
import { ThemeContext } from "../ThemeContext";
import { Link } from "react-router-dom";
import veridian from "../../assets/veridian.png";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

export const Footer = () => {
    const [theme] = useContext(ThemeContext) as ["light" | "dark", React.Dispatch<React.SetStateAction<"light" | "dark">>];
    const { t } = useTranslation();
    return (
        
        <footer className={`pt-10 sm:pt-20 ${theme}`}> 
            <div className="footer-main mb-10 sm:mb-16 text-center sm:text-left">
                <div className="container">
                    <div className="grid sm:grid-cols-3 gap-10 sm:gap-4">
                        <div>
                            <Link to="/">
                                <img className="footer-logo mx-auto sm:mx-0" src={veridian} alt="logo" />
                            </Link>
                            <p className="text-sm mx-auto sm:mx-0 max-w-3xs sm:max-w-3xs mt-2">{t('footer.description')}</p>
                        </div>
                        <div className="">
                            <h5 className="text-md font-bold mb-2">Menu</h5>
                            <ul className="leading-6 text-sm">
                                <li><NavLink to="/" className={({ isActive }) => isActive ? 'active' : ''}>{t('menu.home')}</NavLink></li>
                                <li><NavLink to="/blog">{t('menu.blog')}</NavLink></li>
                                <li><NavLink to="/contact">{t('menu.contact')}</NavLink></li>
                            </ul>
                        </div>
                        <div className="">
                            <h5 className="text-md font-bold mb-2">{t('footer.socialTitle')}</h5>
                            <ul className="leading-6 text-sm">
                                <li><a href="https://www.facebook.com/" target="_blank" rel="noopener noreferrer">Facebook</a>   </li>
                                <li><a href="https://www.linkedin.com/" target="_blank" rel="noopener noreferrer">Linkedin</a></li>
                                <li><a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer">Instagram</a></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <div className="footer-bottom py-5 text-sm">
                <div className="container">
                    <div className="mx-auto sm:flex text-center sm:justify-between">
                        <p>{t('footer.copy')}</p>
                        <p> {t('footer.madeBy')} <a 
                                href="https://www.linkedin.com/in/adam-hudak1/" 
                                target="_blank" 
                                rel="noopener noreferrer"
                                className="dark:hover:text-gray-600 font-bold"
                            >
                                adamhudak
                            </a> 
                        </p>
                    </div>
                </div>
            </div>
          
        </footer>
    )
}
